import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { BookOpen } from "lucide-react";

const VERSES = [
  { ref: "João 3:16",        query: "john+3:16",           fallback: "Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito, para que todo aquele que nele crê não pereça, mas tenha a vida eterna." },
  { ref: "Filipenses 4:13",  query: "philippians+4:13",    fallback: "Posso tudo naquele que me fortalece." },
  { ref: "Romanos 8:28",     query: "romans+8:28",         fallback: "E sabemos que todas as coisas contribuem juntamente para o bem daqueles que amam a Deus, daqueles que são chamados segundo o seu propósito." },
  { ref: "Jeremias 29:11",   query: "jeremiah+29:11",      fallback: "Porque eu bem sei os pensamentos que tenho a vosso respeito, diz o Senhor; pensamentos de paz, e não de mal, para vos dar o fim que esperais." },
  { ref: "Salmos 23:1",      query: "psalms+23:1",         fallback: "O Senhor é o meu pastor; nada me faltará." },
  { ref: "Isaías 40:31",     query: "isaiah+40:31",        fallback: "Mas os que esperam no Senhor renovarão as suas forças, subirão com asas como águias; correrão e não se cansarão; caminharão e não se fatigarão." },
  { ref: "Josué 1:9",        query: "joshua+1:9",          fallback: "Não te mandei eu? Sê forte e corajoso; não te atemorizes, nem te espantes, porque o Senhor, teu Deus, é contigo por onde quer que andares." },
  { ref: "Salmos 46:1",      query: "psalms+46:1",         fallback: "Deus é o nosso refúgio e fortaleza, socorro bem presente na angústia." },
  { ref: "Provérbios 3:5-6", query: "proverbs+3:5",        fallback: "Confia no Senhor de todo o teu coração, e não te estribes no teu próprio entendimento. Reconhece-o em todos os teus caminhos, e ele endireitará as tuas veredas." },
  { ref: "Mateus 6:33",      query: "matthew+6:33",        fallback: "Mas buscai primeiro o reino de Deus e a sua justiça, e todas essas coisas vos serão acrescentadas." },
  { ref: "1 Coríntios 13:4", query: "1+corinthians+13:4",  fallback: "O amor é sofredor, é benigno; o amor não é invejoso; o amor não trata com leviandade, não se ensoberbece." },
  { ref: "Salmos 121:1-2",   query: "psalms+121:1",        fallback: "Levanto os meus olhos para os montes, de onde vem o meu socorro. O meu socorro vem do Senhor, que fez o céu e a terra." },
  { ref: "Gálatas 2:20",     query: "galatians+2:20",      fallback: "Já estou crucificado com Cristo; e vivo, não mais eu, mas Cristo vive em mim." },
  { ref: "Efésios 2:8",      query: "ephesians+2:8",       fallback: "Porque pela graça sois salvos, por meio da fé; e isso não vem de vós; é dom de Deus." },
  { ref: "2 Timóteo 1:7",    query: "2+timothy+1:7",       fallback: "Porque Deus não nos deu o espírito de temor, mas de fortaleza, e de amor, e de moderação." },
  { ref: "João 14:6",        query: "john+14:6",           fallback: "Disse-lhe Jesus: Eu sou o caminho, e a verdade, e a vida. Ninguém vem ao Pai senão por mim." },
  { ref: "Salmos 37:4",      query: "psalms+37:4",         fallback: "Deleita-te também no Senhor, e ele te concederá os desejos do teu coração." },
  { ref: "Isaías 41:10",     query: "isaiah+41:10",        fallback: "Não temas, porque eu sou contigo; não te assombres, porque eu sou o teu Deus; eu te fortaleço, e te ajudo, e te sustento com a minha destra fiel." },
  { ref: "Hebreus 11:1",     query: "hebrews+11:1",        fallback: "Ora, a fé é o firme fundamento das coisas que se esperam, e a prova das coisas que se não vêem." },
  { ref: "João 16:33",       query: "john+16:33",          fallback: "Estas coisas vos disse, para que tenhais paz em mim. No mundo tereis tribulações; mas tende bom ânimo, eu venci o mundo." },
  { ref: "Romanos 12:2",     query: "romans+12:2",         fallback: "E não vos conformeis com este século, mas transformai-vos pela renovação da vossa mente, para que experimenteis qual seja a boa, agradável, e perfeita vontade de Deus." },
  { ref: "Salmos 119:105",   query: "psalms+119:105",      fallback: "Lâmpada para os meus pés é a tua palavra, e luz para o meu caminho." },
  { ref: "Miquéias 6:8",     query: "micah+6:8",           fallback: "Já te foi declarado, ó homem, o que é bom; e que é o que o Senhor pede de ti, senão que pratiques a justiça, e ames a misericórdia, e andes humildemente com o teu Deus?" },
  { ref: "Mateus 11:28",     query: "matthew+11:28",       fallback: "Vinde a mim, todos os que estais cansados e oprimidos, e eu vos aliviarei." },
  { ref: "Filipenses 4:6-7", query: "philippians+4:6",     fallback: "Não estejais ansiosos por coisa alguma; antes em tudo apresentai as vossas petições a Deus em oração e súplica, com ação de graças; e a paz de Deus, que excede todo o entendimento, guardará os vossos corações e os vossos pensamentos em Cristo Jesus." },
  { ref: "1 João 4:19",      query: "1+john+4:19",         fallback: "Nós amamos a Deus, porque ele nos amou primeiro." },
  { ref: "Salmos 16:8",      query: "psalms+16:8",         fallback: "Tenho posto o Senhor continuamente diante de mim; porque ele está à minha mão direita, não serei abalado." },
  { ref: "2 Coríntios 5:17", query: "2+corinthians+5:17",  fallback: "Assim que, se alguém está em Cristo, nova criatura é; as coisas velhas já passaram; eis que tudo se fez novo." },
  { ref: "Apocalipse 3:20",  query: "revelation+3:20",     fallback: "Eis que estou à porta e bato; se alguém ouvir a minha voz e abrir a porta, entrarei em sua casa e cearei com ele, e ele comigo." },
  { ref: "Efésios 3:20",     query: "ephesians+3:20",      fallback: "Ora, àquele que é poderoso para fazer tudo muito mais abundantemente além daquilo que pedimos ou pensamos, segundo o poder que em nós opera." },
];

function getDayOfYear() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  return Math.floor((now - start) / 86400000);
}

export default function DailyVerse() {
  const [text, setText] = useState("");
  const [ref, setRef] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const todayVerse = VERSES[getDayOfYear() % VERSES.length];
    setRef(todayVerse.ref);

    fetch(`https://bible-api.com/${todayVerse.query}?translation=almeida`)
      .then((r) => r.json())
      .then((data) => {
        setText(data.text?.trim().replace(/\n/g, " ") || todayVerse.fallback);
      })
      .catch(() => {
        setText(todayVerse.fallback);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      className="bg-[#080808] border-y border-white/5 py-16 sm:py-20 overflow-hidden"
      data-testid="daily-verse-section"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs tracking-overline uppercase text-[#D4AF37] mb-8"
        >
          Versículo do Dia
        </motion.p>

        {loading ? (
          <div className="space-y-3 animate-pulse">
            <div className="h-6 bg-white/5 rounded mx-auto w-3/4" />
            <div className="h-6 bg-white/5 rounded mx-auto w-2/3" />
            <div className="h-6 bg-white/5 rounded mx-auto w-1/2" />
          </div>
        ) : (
          <>
            <motion.blockquote
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 }}
              data-testid="daily-verse-text"
              className="font-serif-display italic text-2xl sm:text-3xl lg:text-4xl text-white/90 leading-relaxed tracking-tight"
            >
              <span className="text-[#D4AF37] text-5xl leading-none select-none mr-1">"</span>
              {text}
              <span className="text-[#D4AF37] text-5xl leading-none select-none ml-1">"</span>
            </motion.blockquote>

            <motion.cite
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              data-testid="daily-verse-ref"
              className="mt-6 block text-sm tracking-overline uppercase text-[#D4AF37] not-italic"
            >
              — {ref}
            </motion.cite>

            <motion.div
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="mt-10"
            >
              <a
                href="https://www.bible.com/pt"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 border border-[#D4AF37]/40 text-[#D4AF37] text-sm tracking-wide px-6 py-3 hover:bg-[#D4AF37]/10 transition-colors duration-300"
                data-testid="read-bible-link"
              >
                <BookOpen size={15} strokeWidth={1.5} />
                Leia a Bíblia completa
              </a>
            </motion.div>
          </>
        )}
      </div>
    </section>
  );
}
